import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const BusinessRegistrationsApprovalsLicenses = () => {
  const serviceData = {
    title: "Business Registrations, Approvals & Licenses",
    heading: "Business Registrations, Approvals & Licenses",
    image: subTopicImages["Business Registrations, Approvals & Licenses"],
    intro:
      "End-to-end assistance for statutory registrations & regulatory approvals in India",
    description: [
      "Before commencing operations in India, businesses must obtain various registrations and approvals at the central, state and local levels. Requirements vary based on business activity, industry sector, employment size and location.",
      "At V DOOGAR AND ASSOCIATES, we manage the complete licensing and registration process — ensuring your business meets all statutory requirements accurately and on time.",
      "Our regulatory team coordinates with authorities and prepares documentation, allowing you to begin operations smoothly and without delays.",
    ],
    services: [
      {
        title: "Business Registrations",
        text: "Support includes:",
        list: [
          "Company incorporation",
          "LLP and branch / liaison registration",
          "PAN & TAN applications",
          "GST registration",
          "Import Export Code (IEC)",
          "Professional Tax & Shops registration",
          "EPF & ESIC registrations",
        ],
        extraInfo:
          "Ensuring your business is legally ready to operate from the start.",
      },
      {
        title: "Industry-Specific Approvals",
        text: "We assist with approvals such as:",
        list: [
          "FSSAI",
          "Labour registrations",
          "Trade licenses",
          "Environmental approvals",
          "Factories licensing",
          "Shop & Establishment registration",
          "MSME / Start-Up India enrollment",
          "Sector-specific clearances",
        ],
        extraInfo:
          "Approvals are handled based on the nature, scale and location of your business.",
      },
      {
        title: "Compliance Support",
        text: "We help maintain ongoing compliance including:",
        list: [
          "periodic renewals",
          "license modifications",
          "regulatory updates",
          "inspection support",
        ],
        extraInfo:
          "So your organisation remains fully compliant throughout its operations.",
      },
    ],
    benefitsIntro: "Benefits of this service:",
    benefits: [
      "Smooth business launch without delays",
      "Accurate compliance with Indian regulations",
      "Reduced administrative burden",
      "Centralised documentation & support",
      "Trusted advisory for foreign promoters",
    ],
    research:
      "Our licensing specialists ensure efficient execution, clear communication and strict compliance discipline — helping your business begin and operate confidently in India.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default BusinessRegistrationsApprovalsLicenses;
